export const basicImgUrlPath = "https://image.tmdb.org/t/p/original/";
